<template>
  <div class="app-container-v2 process-content-container">
    <div class="tabs-container flex aend pl4">
      <el-tabs v-model="currentTab" class="air-recover-element" @tab-click="changeTab">
        <el-tab-pane label="发薪信息" name="发薪信息" />
        <el-tab-pane label="退票信息" name="退票信息" :disabled="tabDisabled" />
      </el-tabs>
    </div>

    <div v-show="currentTab === '发薪信息'" class="flex vertical p24 table-body" v-loading="tabs.发薪信息.loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          :show-operation="false"
          align="center"
          :columns="tabs.发薪信息.columns"
          :data="tabs.发薪信息.tableData"
          @change-filter="changeFilter"
      ></air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="tabs.发薪信息.queryParams.page"
          :page-size.sync="tabs.发薪信息.queryParams.limit"
          :total="tabs.发薪信息.total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <div v-if="render" v-show="currentTab === '退票信息'" class="flex vertical p24 table-body" v-loading="tabs.退票信息.loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="tabs.退票信息.columns"
          :data="tabs.退票信息.tableData"
          @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">更正账户信息</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="tabs.退票信息.queryParams.page"
          :page-size.sync="tabs.退票信息.queryParams.limit"
          :total="tabs.退票信息.total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <el-dialog class="modal-v2" title="更正账户信息" :visible.sync="modalShow" :close-on-click-modal="false" width="700px" append-to-body v-dialog-drag>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" label-width="110px" style="margin: 40px 0; padding: 0 30px;" size="small">
          <el-form-item label="开户名：" prop="upOpenName">
            <el-input v-model="form.upOpenName" class="input-v2" placeholder="请输入开户名" maxlength="30" />
          </el-form-item>
          <el-form-item label="账号地区：" prop="upAccountArea">
            <el-input v-model="form.upAccountArea" class="input-v2" placeholder="请输入账号地区" maxlength="50" />
          </el-form-item>
          <el-form-item class="fixed-height" label="开户行：" prop="bankType">
            <el-select v-model="form.bankType" placeholder="请选择开户行" filterable>
              <el-option v-for="item in dictData.开户行" :key="item.codeItemId" :value="item.codeItemId" :label="item.codeItemName" />
            </el-select>
          </el-form-item>
          <el-form-item label="开户行全称：" prop="upBankFullName">
            <el-input v-model="form.upBankFullName" class="input-v2" placeholder="请输入开户行全称" maxlength="100" />
          </el-form-item>
          <el-form-item label="开户账号：" prop="upAccountNumber">
            <el-input v-model="form.upAccountNumber" class="input-v2" placeholder="请输入开户账号" maxlength="50" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="modalShow = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      render: false,
      currentTab: '发薪信息',
      tabDisabled: true,
      dictMap: {},
      dictData: {},
      tabs: {
        发薪信息: {
          api: api.getBizSalaryByPage,
          loading: false,
          queryParams: {
            page: 1,
            limit: 10,
          },
          total: 0,
          columns: [
            {title: '姓名', field: '姓名', minWidth: 100, filterType: 'input'},
            {title: '证件号码', field: '证件号码', minWidth: 120, filterType: 'input'},
            {title: '电话', field: '电话', minWidth: 100},
            {title: '发放时间', field: '发放时间', minWidth: 120},
            {title: '开户名', field: '开户名', minWidth: 100},
            {title: '开户行', field: '开户行', minWidth: 100},
            {title: '开户账号', field: '开户账号', minWidth: 100},
            {title: '应发金额', field: '应发金额', money: true, minWidth: 100},
            {title: '税金', field: '税金', money: true, minWidth: 100},
            {title: '实发金额', field: '实发金额', money: true, minWidth: 100},
          ],
          tableData: [],
        },
        退票信息: {
          api: api.refundlistpage,
          loading: false,
          queryParams: {
            page: 1,
            limit: 10,
          },
          total: 0,
          columns: [
            {title: '姓名', field: 'empName', minWidth: 100, filterType: 'input'},
            {title: '证件号码', field: 'identityNum', minWidth: 120, filterType: 'input'},
            {title: '退票银行', field: 'refundBankTypeText', minWidth: 100},
            {title: '开户名', field: 'upOpenName', minWidth: 100},
            {title: '开户行', field: 'bankTypeText', minWidth: 100},
            {title: '开户账号', field: 'upAccountNumber', minWidth: 100},
            {title: '退票原因', field: 'bankFeedback', minWidth: 100},
            {title: '退票金额', field: 'amount', money: true, minWidth: 100},
            {title: '退票时间', field: 'recordTime', minWidth: 100},
            {title: '是否已更新', field: 'isUpdate', minWidth: 80},
          ],
          tableData: [],
        }
      },
      modalShow: false,
      form: {},
      formRules: {
        upOpenName: [{ required: true, message: '请输入开户名', trigger: 'blur' }],
        upAccountArea: [{ required: true, message: '请输入账号地区', trigger: 'blur' }],
        bankType: [{ required: true, message: '请选择开户行', trigger: 'change' }],
        upBankFullName: [{ required: true, message: '请输入开户行全称', trigger: 'blur' }],
        upAccountNumber: [{ required: true, message: '请输入开户账号', trigger: 'blur' }],
      },
      submitLoading: false
    }
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await this.getData()
      // 确保从发薪信息接口获取了字典配置之后，才能切换至退票信息页签，否则会导致退票信息中银行字典转义失败
      this.tabDisabled = false
    },
    getData() {
      this.tabs[this.currentTab].loading = true
      this.tabs[this.currentTab].queryParams.orderId = this.data.orderInfo.id
      this.tabs[this.currentTab].queryParams.cusId = this.$userInfo.cusId
      return this.tabs[this.currentTab].api(this.tabs[this.currentTab].queryParams).then(res => {
        let result = this.handleData(res.data.data)
        this.tabs[this.currentTab].tableData = result.records
        this.tabs[this.currentTab].total = result.total
        this.tabs[this.currentTab].loading = false
      })
    },
    handleData(data) {
      if (this.currentTab === '发薪信息') {
        if (!this.dictMap.开户行) {
          this.dictData.开户行 = data.translates['1016']
          this.dictMap.开户行 = this.$arrayToObj(data.translates['1016'], 'codeItemId')
          this.dictData.发放状态 = data.translates['3056']
          this.dictMap.发放状态 = this.$arrayToObj(data.translates['3056'], 'codeItemId')
        }
        data.data.data.forEach(item => {
          item.开户行 = item.开户行 && this.dictMap.开户行[item.开户行] && this.dictMap.开户行[item.开户行].codeItemName
          if (item.发放状态 !== '30560005') {
            item.发放时间 = item.发放状态 && this.dictMap.发放状态[item.发放状态] && this.dictMap.发放状态[item.发放状态].codeItemName
          }
        })
        return {
          records: data.data.data,
          total: data.data.total
        }
      }
      else {
        data.records.forEach(item => {
          item.isUpdate = item.upAccountNumber ? '是' : '否'
          item.upOpenName = item.upOpenName || item.accountName
          item.bankType = item.upBankType || item.bankType
          item.upAccountNumber = item.upAccountNumber || item.accountNo
          item.refundBankTypeText = this.dictMap.开户行[item.refundBankType].codeItemName
          item.bankTypeText = this.dictMap.开户行[item.bankType].codeItemName
        })
        return data
      }
    },
    changeFilter(e) {
      this.tabs[this.currentTab].queryParams = {...this.tabs[this.currentTab].queryParams, ...e.filterData}
      this.getData()
    },
    changeTab() {
      if (!this.render) {
        this.getData()
        // 首次切换tab时再渲染表格，否则会显示异常
        this.render = true
      }
    },
    handleEdit(row) {
      this.form = {
        cusId: this.$userInfo.cusId,
        upOpenName: row.upOpenName || row.accountName,
        identityNum: row.identityNum,
        upAccountArea: row.upAccountArea || row.bankAccountArea,
        bankType: row.upBankType || row.bankType,
        upBankFullName: row.upBankFullName || row.bankFullName,
        upAccountNumber: row.upAccountNumber || row.accountNo,
        refundId: row.backId
      }
      this.submitLoading = false
      this.modalShow = true
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          api.updaterefundinfo(this.form).then(res => {
            if (res.data.code === 0) {
              this.$msgSuccess('更正成功')
              this.getData()
              this.modalShow = false
            }
          }).finally(() => this.submitLoading = false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.tabs-container {
  height: 60px;
  flex: 0 0 60px;
  border-bottom: 1px solid #E8E8E8;

  ::v-deep {
    .el-tabs__content {
      display: none !important;
    }
    .el-tabs__header {
      margin: 0 36px 0 0 !important;
    }
    .el-tabs__nav-wrap:after {
      background-color: transparent !important;
    }
    .el-tabs__item {
      height: 24px !important;
      font-size: 18px !important;
      font-family: PingFangSC-Medium, PingFang SC !important;
      font-weight: 500 !important;
      color: #1C1C1C !important;
      line-height: 24px !important;
      margin-bottom: 15px !important;

      &:hover, &.is-active {
        color: #FF9601 !important;
      }
    }
    .el-tabs__active-bar {
      background-color: #FF9601 !important;
    }
  }
}
</style>
